import React, { useEffect, useState } from "react";
import Axios from "axios";
import "./styles.scss";
import { useHistory } from "react-router-dom";
import { grievanceEmail } from "../../config/legalEmails";

const HorizonTNC = () => {
  const [setLoading] = useState(false);
  const [setResponse] = useState([]);
  const history = useHistory();
  const [licenseType, setLicenseType] = useState();

  useEffect(() => {
    history.location.pathname.indexOf("android")
      ? setLicenseType("android")
      : setLicenseType("ios");
  }, [history.location.pathname]);

  useEffect(() => {
    // getLicenseInfo();
  }, []);

  return (
    <div
      className="tnc-jioimmerse-wrapper"
      spellCheck="false"
      tabIndex={0}
      contentEditable="false"
    >
      <div className="tnc-jioimmerse-wrapper-info">
        <h3 id="tnc-jioimmerse-wrapper-inner" className>
          Terms of Service - Tesseract Horizons{" "}
        </h3>
      </div>
      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>1. SCOPE&nbsp;</strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.1&nbsp;</li>
        <li>
          Tesseract Horizons is a web based portal (hereinafter referred to as{" "}
          <strong>“Portal”</strong>) owned and provided by Tesseract Imaging
          Limited <strong> (“Company”, “Tesseract”, “we” or “us”)</strong>,
          located at T22C, Reliance Corporate Park, Ghansoli, Navi Mumbai 400
          701.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.2&nbsp;</li>
        <li>
          The Portal is designed and made available by the Company to provide to
          its users, the following mobility services: (i) content creation
          services designed specifically for metaverse, augmented reality,
          virtual reality and immersive 360-degree digital walkthrough
          experiences; (ii) enabling you to oversee user access, content
          permissions, system configurations and monitor usage analytics of the
          Services on the Portal; (iii) customisation and integration of
          features of the Portal with your existing software; (iv) facilitation
          of distribution and accessibility of created content; and (v) such
          other services as may be provided by the Company from time to time
          (collectively known as “Services”) on any compatible web browser
          installed in a laptop/desktop or smart phones/ devices powered by
          Android and iOS
          <strong>(“Device”)</strong>. For better experience, this Portal may be
          used with the augmented reality, virtual reality and/ or mixed reality
          products of Tesseract and/ or its affiliates.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.3&nbsp;</li>
        <li>
          Your <strong>(“you”, “your” or “user”)</strong> use of the Portal is
          subject to these Terms of Service <strong>(“Terms”)</strong>.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.4&nbsp;</li>
        <li>
          Your use of the Portal on the Device requires that you agree to these
          Terms and the privacy policy of the Portal
          <strong>(“Privacy Policy”)</strong>. By downloading the Portal and by
          registering or signing up to the Portal, or otherwise having access
          to, receiving, and/or using the Portal, you acknowledge to have read,
          understood and you consent to be governed and bound by these Terms and
          the Privacy Policy of the Portal. If you do not understand the Terms
          or the Privacy Policy of the Portal, or do not accept any part of
          them, then you should not use the Portal.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.5&nbsp;</li>
        <li>
          The Terms are an electronic record in terms of the Information
          Technology Act, 2000 (as amended / re-enacted)
          <strong>(“IT Act”)</strong> and rules thereunder, and is published in
          accordance with the provisions of Rule 3 (1) of Information Technology
          (Intermediaries Guidelines and Digital Media Ethics code) Rules, 2021,
          which mandates for publishing of rules and regulations, privacy policy
          and terms of use for access or usage of Portal. This electronic record
          is generated by a computer system and does not require any physical or
          digital signatures.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>2. PRIVACY AND PROTECTION OF PERSONAL INFORMATION:</strong>
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">2.1&nbsp;</li>
        <li>
          Please refer to the Privacy Policy of the Portal available {" "}
          <a href="/horizons/privacy-policy">here</a>. You confirm that you have
          read, fully understand and accept the Privacy Policy as provided under
          this Clause.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">2.2&nbsp;</li>
        <li>
          Please note that your use of the Portal or Services on compatible web
          browser and your Device may be subject to the respective privacy
          policies as may be published or made available by the web browser and
          Device.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">2.3&nbsp;</li>
        <li>
          If the user wants the Company’s mobility team to delete all personal
          data collected, then he/she needs to send an email
          to {grievanceEmail} in compliance with the terms of the Privacy
          Policy.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>3.MODIFICATIONS</strong>
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">3.1&nbsp;</li>
        <li>
          Modifications of the Terms: The Company reserves the right to change
          the Terms under which the Services are offered, including but not
          limited to the charges, if any, associated with the use of the
          Services. The Terms may be further modified based on changes in the
          business, legal and regulatory requirements and will be updated
          online. We will notify you by way of a notification in the Portal,
          whenever any change to the Terms are made. You are encouraged to
          periodically visit this page to review these Terms and any changes to
          it.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">3.2&nbsp;</li>
        <li>
          Modification of Services: The Company reserves the right to add,
          modify or delete any Content or features available in the Portal
          and/or Services at any time at its sole discretion.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>4. REGISTRATION</strong>
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">4.1&nbsp;</li>
        <li>
          Subject to Clause 10 below, in order to use the Portal and the
          Services, you are required to register with the Company and represent,
          warrant and covenant that you will provide Company with accurate, and
          complete registration information (including, but not limited to your
          name (“Username”), e-mail address and other details you will use to
          access the Service) and keep your registration information accurate
          and up-to-date in compliance with the Terms and the Privacy Policy.
          Failure to do so shall constitute a breach of these Terms, which may
          result in immediate termination and/or suspension of your account with
          the Company with respect to the Services.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">4.2&nbsp;</li>
        <li>
          Registration as a user is only a one-time process and if you have been
          previously registered, you shall login / sign into your account using
          the same credentials as provided by you during the registration
          process.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">4.3&nbsp;</li>
        <li>
          Subject to Clause 10 below, you shall not:
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">4.3.1&nbsp;</li>
            <li>
              provide any false personal information to the Company (including a
              false Username) or create any account for anyone other than
              yourself without such person’s permission;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">4.3.2&nbsp;&nbsp;</li>
            <li>
              use a Username that is the name of another person with the intent
              to impersonate that person;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">4.3.3&nbsp;&nbsp;</li>
            <li>
              use a Username or a company account that is subject to any rights
              of a person other than you without appropriate authorization; or
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">4.3.4&nbsp;&nbsp;</li>
            <li>
              use a Username that is a name that is otherwise offensive, vulgar,
              obscene or otherwise unlawful.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">4.4&nbsp;</li>
        <li>
          The Company reserves the right to refuse registration of, or cancel a
          Username in its sole discretion. You are solely responsible and liable
          for activity that occurs on your account and shall be responsible for
          maintaining the confidentiality of your account’s password.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">4.5&nbsp;</li>
        <li>
          You shall indemnify, defend and hold harmless the Company from any
          loss attributable to activities conducted through your account. You
          shall never use another user’s account without the Company and such
          other user’s prior express permission. You will immediately notify
          Company in writing by way of email to {grievanceEmail}, in case
          of any unauthorized use of your account, or other account related
          security breach of which you are aware.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>5. COMMUNICATION AND UNSUBSCRIPTION:</strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">5.1&nbsp;</li>
        <li>
          You understand that once you have shared your user account information
          and successfully registered on the Portal, you may receive SMS or
          email notifications from Tesseract relating to your registration and
          transactions on the Portal.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">5.2&nbsp;</li>
        <li>
          You may also receive such notifications regarding any marketing /
          promotional activities that maybe available on the Portal from time to
          time. By accepting these Terms, you explicitly consent to receive
          news, updates, offers/ campaign, marketing/ promotional communications
          (through call, SMS, email or other digital and electronic means) from
          us and/or our authorized representatives regarding any new services or
          offerings, even if your contact number is registered under the
          DND/NCPR list under the Telecom Commercial Communications Customer
          Preference Regulations, 2018.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">5.3&nbsp;</li>
        <li>
          You can unsubscribe / opt-out from receiving marketing/ promotional
          communications, newsletters and other notifications from us at any
          time by following the instructions set out in such communications.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>
            6. LINKS TO THIRD PARTY SITES, APPLICATIONS AND THIRD PARTY
            SERVICES:
          </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">6.1&nbsp;</li>
        <li>
          The Company may permit certain third-party service providers to offer
          certain products and services to the users with respect to the Portal,
          and further allow them to use their own cookies or similar
          technologies on the user’s Device to provide such services. Users may,
          at their sole risk and expense, elect to avail such third-party
          services.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">6.2&nbsp;</li>
        <li>
          The Portal may contain links to other web sites/applications (“Linked
          Sites”). The Linked Sites are not under the control of the Company and
          the Company is not responsible for the contents of any Linked Site,
          including without limitation any link contained in a Linked Site, or
          any changes or updates to a Linked Site or any information transmitted
          on a Linked Site. The inclusion of any link does not imply endorsement
          by the Company of the site or any association with its operators
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">6.3&nbsp;</li>
        <li>
          Any dealings with third parties (including advertisers) included
          within or available via a link from the Portal or participation in
          promotions, including the delivery of and the payment for goods and
          services, and any other terms, conditions, warranties or
          representations associated with such dealings or promotions, are
          solely between you and the advertiser or other third party. The
          Company shall not be responsible or liable for any part of any such
          dealings or promotions.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">6.4&nbsp;</li>
        <li>
          You acknowledge and agree that the use of any Linked Sites is governed
          by such third party’s terms of use, license agreement, privacy policy,
          or other such agreement. THE COMPANY DISCLAIMS ANY AND ALL
          RESPONSIBILITY FOR ANY DISCLOSURE OF INFORMATION OR ANY OTHER
          PRACTICES OF ANY THIRD PARTY. THE COMPANY EXPRESSLY DISCLAIMS ANY
          WARRANTY WITH RESPECT TO YOUR PERSONAL OR OTHER INFORMATION THAT MAY
          BE COLLECTED, PROCESSED, SHARED OR RETAINED BY ANY THIRD PARTY.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">6.5&nbsp;</li>
        <li>
          In conjunction with the Services, you may be allowed to use certain
          software (including related support, maintenance, and documentation)
          developed, owned, or provided by third parties or their licensors. Use
          of such third party software and services is subject to the additional
          terms and conditions applicable to such third party software and
          services which are separate and distinct from these Terms. In addition
          to the Terms, you acknowledge and agree to the terms and conditions
          available at (a) https://firebase.google.com/terms; (b)
          https://jiomeetpro.jio.com/terms-condition-business; (c)
          https://www.twilio.com/en-us/legal/tos; (d)
          https://azure.microsoft.com/en-in/support/legal/ that may be
          applicable to the Services. You acknowledge and agree to have read,
          understood, and consented to the terms and conditions set forth under
          this Clause. These third-party service provider terms shall be deemed
          to be an integral component of the Terms. By utilizing the Services,
          you signify your understanding and acceptance of the incorporation of
          such third-party terms and conditions into these Terms.{" "}
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">6.6&nbsp;</li>
        <li>
          In regard to the use of any other third-party software and services,
          you acknowledge that their applicable terms and conditions govern your
          use, and it is your sole responsibility to read, understand and adhere
          to such terms and conditions. The Company will not assume any
          liability for performance-related issues, damages, or consequences
          arising from the utilization of such third-party software and
          services. Any warranties or support offered for these third-party
          software and services, if any, are solely the responsibility of the
          respective third-party service provider. We explicitly disclaim and
          further state that we bear no responsibility for any consequences or
          liabilities resulting from the use of such third-party services.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>7. INTELLECTUAL PROPERTY RIGHTS: </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">7.1&nbsp;</li>
        <li>
          The Company shall own title, interest and rights, including all
          related intellectual property rights, in/of the Portal including but
          not limited to object code of the Portal, features of Services, which
          is/are protected by the applicable laws except the Customer Content
          owned by the user. You acknowledge that such ownership shall include
          all intellectual property rights arising from any suggestions,
          enhancement requests, recommendations or other information provided by
          the user, whether in the course of use of the Portal, your Device or
          otherwise.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">7.2&nbsp;</li>
        <li>
          Subject to your compliance with these Terms, Tesseract grants you a
          personal, non-commercial, non-exclusive, non-transferable, not
          sublicensable, revocable and limited license to download, view,
          display, and use the Content solely for your permitted use within the
          Services. “Content” means the text, software, scripts, graphics,
          photos, sounds, music, videos, audiovisual combinations,
          communications, interactive features, works of authorship of any kind,
          and information or other materials that are generated, provided, or
          otherwise made available through the Services, including Customer
          Content. “Customer Content” means any Content a user of a Service
          provides to be made available through Services (for example, any
          application or website content created and managed by you using the
          Services).
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">7.3&nbsp;</li>
        <li>
          Tesseract does not claim ownership rights in Customer Content and
          nothing in these Terms restricts any rights that you may have to use
          and exploit your Customer Content. Subject to the foregoing, Tesseract
          and its licensors exclusively own all right, title, and interest in
          and to the Services and Content, including all associated intellectual
          property rights. You acknowledge that the Services and Content are
          protected by copyright, trademark, and other applicable laws.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">7.4&nbsp;</li>
        <li>
          By making any Customer Content available through the Services you
          grant to Tesseract a non-exclusive, transferable, sub-licensable,
          worldwide, royalty-free, perpetual license (or, if not permitted under
          applicable law, a license for the whole duration, including for any
          extension thereof, of all relevant rights under any applicable law),
          to use, copy, modify, create derivative works based upon, publicly
          display, publicly perform, market, promote and distribute your
          Customer Content in connection with operating and providing the
          Services and Content to you and to others. By accepting these terms,
          you allow Tesseract to benefit freely from the above rights, including
          but not limited to:
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">7.4.1&nbsp;</li>
            <li>
              The right to reproduce Customer Content by any means and in any
              form.
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">7.4.2&nbsp;</li>
            <li>
              The right to publicly or privately broadcast or make available the
              Customer Content (or any product incorporating the Customer
              Content), in return for payment or free of charge in all places by
              any means or process known or unknown at the present time, and in
              particular via internet, pay per view, pay per play, theatrical or
              television broadcasting, and print.{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">7.4.3&nbsp;</li>
            <li>
              The right to use the Customer Content for demonstration, promotion
              and advertising for all Services.{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">7.4.4&nbsp;</li>
            <li>
              The right to produce or order the production of any new product or
              service from the Customer Content or from any product
              incorporating or exploiting the Customer Content, either
              reproduced as it stands or modified by Tesseract or by any outside
              party of its choice.{" "}
            </li>
          </ul>
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">7.5&nbsp;</li>
        <li>
          ‘Tesseract’, ‘Tesseract Horizons’ and related icons and logos are
          registered trademarks or trademarks pending registration in the name
          of the Company in various jurisdictions and the same is protected
          under applicable trademark and other intellectual property laws. The
          unauthorized copying, modification, use or publication of these marks
          is strictly prohibited and shall be subject to appropriate legal
          proceedings against the unauthorized user. All Content in the Services
          is the copyright of the Company except any third party content and
          links to third party websites within the Portal, if any.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>8.GRANT OF RIGHTS: &nbsp;</strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">8.1&nbsp;</li>
        <li>
          In order to provide certain Services and features of the Portal, the
          Company may allow the user(s) to share their screen while conducting
          video or audio conferencing with other user(s). The Privacy Policy for
          such sharing is available at here.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">8.2&nbsp;</li>
        <li>
          The Company allows the user who participates in the video or audio
          conferencing (“Participant”) to record the video or audio
          conferencing. The Privacy Policy for such sharing is available
          at here. Once the Participant starts recording a video you would be
          able to see the recording sign. Your continued use of the Application
          even after seeing the recording sign would be taken as your deemed
          consent. In case you do not wish for the audio or video conference to
          be recorded you may leave the conference at any time after you have
          noticed that the conference is being recorded.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>9.USE LIMITATIONS: </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">9.1&nbsp;</li>
        <li>
          The Portal is merely intended as a means to access and use internet
          based experiences using augmented reality, virtual reality and/ or
          mixed reality technology, as the case maybe.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">9.2&nbsp;</li>
        <li>
          As a condition of your use of the Portal, you warrant to the Company
          that you will not use the Portal for any purpose that is unlawful or
          prohibited by these Terms. You may not use the Portal in any manner
          which could damage, disable, overburden or impair the Services or
          interfere with any other user’s use and enjoyment of the Portal and
          Services. You are responsible for all of your activity in connection
          with the Services. Additionally, you shall abide by all applicable
          local, state, national and international laws and regulations and, if
          you represent a business or enterprise, any advertising, marketing,
          privacy, or other self-regulatory code(s) applicable to your industry.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">9.3&nbsp;</li>
        <li>
          You are not entitled to use any kind of measures, mechanisms or tools
          (software or hardware) that could interfere with the functioning of
          the Portal or any of its Services.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">9.4&nbsp;</li>
        <li>
          You shall not (directly or indirectly):
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">9.4.1&nbsp;</li>
            <li>
              take any action that imposes or may impose (as determined by
              Company in its sole discretion) an unreasonable or
              disproportionately large load on Company’s (or its third party
              providers’) infrastructure;{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">9.4.2&nbsp;</li>
            <li>
              interfere or attempt to interfere with the proper working of the
              Service or any activities conducted on the Service;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">9.4.3&nbsp;</li>
            <li>
              bypass any measures Company may use to prevent or restrict access
              to the Service (or other accounts, computer systems or networks
              connected to the Service);
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">9.4.4&nbsp;</li>
            <li>
              run any form of auto-responder or “spam” on the Portal or the
              Service;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">9.4.5&nbsp;</li>
            <li>
              use manual or automated software, devices, or other processes to
              “crawl” or “spider” any part of the Portal;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">9.4.6&nbsp;</li>
            <li>harvest or scrape any content from the Service;</li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">9.4.7&nbsp;</li>
            <li>
              modify, adapt, appropriate, reproduce, distribute, translate,
              create derivative works or adaptations of, publicly display,
              republish, repurpose, sell, trade, or in any way exploit the
              Service or Portal, except as expressly authorized by Company;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">9.4.8&nbsp;</li>
            <li>
              decipher, decompile, disassemble, reverse engineer or otherwise
              attempt to derive any hardware, or source code or underlying ideas
              or algorithms of any part of the Service (including without
              limitation any application or widget), except to the limited
              extent applicable laws specifically prohibit such restriction;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">9.4.9&nbsp;</li>
            <li>
              copy, rent, lease, distribute, or otherwise transfer any of the
              rights that you receive hereunder;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">9.4.10&nbsp;</li>
            <li>
              delete or modify any Content of the Portal and / or the Services,
              including but not limited to, legal notices, disclaimers or
              proprietary notices such as copyright or trademark symbols, logos,
              that you do not own or have express permission to modify;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">9.4.11&nbsp;</li>
            <li>
              use the Portal or any Services in any unlawful manner, for any
              unlawful purpose, or in any manner inconsistent with these Terms,
              or act fraudulently or maliciously, for example, by hacking into
              or inserting malicious code, including viruses, or harmful data,
              into the Portal, any Services or any operating system;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">9.4.12&nbsp;</li>
            <li>
              make false or malicious statements against the Services or the
              Portal or Company; or
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">9.4.13&nbsp;</li>
            <li>
              otherwise take any action in violation of Company’s guidelines and
              policies.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">9.5&nbsp;</li>
        <li>
          You may not use the Services and/or Portal if (i) you have been
          convicted of any offence under applicable law; and/or (ii) if you are
          under the age of 18 (Eighteen) years.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>10.TESSERACT HORIZONS (ENTERPRISE VERSION): &nbsp;</strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">10.1&nbsp;</li>
        <li>
          The following conditions shall additionally apply to use of the Portal
          by an enterprise, being any person, company, limited liability
          partnership firm, partnership firm, registered society, trust and/or
          association of persons (“Enterprise”) for the purposes of use of the
          Services by the Enterprise: (a) through its employees, consultants and
          contractors; and (b) for its end-customers:
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">10.1.1&nbsp;</li>
            <li></li>
            Registration: In order to use the Services through the Portal, the
            Enterprise availing the Services for the purposes of use by its
            employees, consultants, contractors and end-customers, is required
            to sign up for an administrator account (“Administrator Account”)
            subject to such commercial terms and User Account limitations as may
            be specified by the Company and updated and/or modified by the
            Company from time to time.
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">10.1.2&nbsp;</li>
            <li>
              The Administrator Account, upon being successfully created, shall
              be used by the Enterprise to open or create such employee,
              consultant, contractor and/ or end-customer accounts as may be
              availed by the Enterprise in accordance with Clause 10.1.1 (each
              an “User Account”).
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">10.1.3&nbsp;</li>
            <li>
              The User Accounts created shall be non-transferable and meant for
              such use as may be authorized by the Enterprise. Notwithstanding
              the foregoing but without prejudice to the absolute obligation of
              the Enterprise to ensure compliance, the use of the Services and
              Portal by the Enterprise, including its User Accounts, shall be
              strictly for the purposes of internal business use of the
              Enterprise (unless otherwise expressly agreed in writing) and
              shall, at all times, be in accordance with such terms and
              conditions, including limitations, as may be prescribed by the
              Company from time to time. An Administrator Account and each User
              Account shall be used by only one user each and no second person/
              user shall access the Portal and Services using anybody else’s
              User Account.{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">10.1.4&nbsp;</li>
            <li>
              The Enterprise assures to provide us with accurate, complete, and
              updated registration information about yourself or authorized
              personnel of your organisation.{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">10.1.5&nbsp;</li>
            <li>
              The Administrator Account, each User Account and each end-customer
              of the Enterprise shall be treated as a user for the purposes of
              these Terms and wherever the expression user is employed, it shall
              mean and include the Administrator Account, each User Account and
              each end-customer of the Enterprise. In addition to compliance
              obligation of the individual users behind the Administrator
              Account, each User Account and each end-customer of the
              Enterprise, the Enterprise shall also be responsible for
              compliance of these Terms by the Administrator Account, each User
              Account and each end-customer of the Enterprise. In the event that
              an Enterprise utilizes the Portal and/or Services, it is expressly
              clarified that any and all references to 'you,' 'your,' or 'user'
              within these Terms shall encompass and apply to the said
              Enterprise. The Enterprise shall assume all obligations,
              responsibilities, and entitlements set forth in these Terms, and
              all actions, representations, or conduct made by its authorized
              representatives or individual users including but not limited to
              its employees, consultants, contractors and end-customers
              accessing or using the Portal and/or Services shall be considered
              as actions, representations, or conduct of the Enterprise itself.{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">10.1.6&nbsp;</li>
            <li>
              The Enterprise will be charged with the subscription/ license fees
              as has been agreed by the Enterprise and the Company.{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">10.1.7&nbsp;</li>
            <li>
              The Administrator Account and respective User Accounts will be
              active and such subscription will automatically renew every
              billing cycle, until the Enterprise cancels the subscription in
              the manner as stipulated by the Company from time to time or the
              Company cancels the subscription on account of breach of these
              Terms by the Administrator Account and/ or User Account and/ or
              end-customer of the Enterprise or breach by the Enterprise of the
              terms agreed between such Enterprise and the Company. The Company
              shall intimate the Administrator Account about renewal of
              subscription through the Portal before the expiry of the any
              existing subscription.{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">10.1.8&nbsp;</li>
            <li>
              The Company does not offer refunds or credits for partial periods
              of service, or unused months. Please note that if the Enterprise
              cancels the Administrator Account or any User Account, the
              Enterprise will not be eligible for any refunds or credits for any
              charges incurred during the previous billing cycle.{" "}
            </li>
          </ul>
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>11. GENERAL: </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">11.1&nbsp;</li>
        <li>
          By using our Services, you hereby agree to ensure that the explicit
          prohibitions mentioned in Clause 11.3 are at all times adhered to. You
          are authorized by the entity on whose behalf you are accessing and
          accepting these Terms and will bind such entity to these Terms.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">11.2&nbsp;</li>
        <li>
          Use Restriction: You must not access the Portal if you are a person
          who is either barred or otherwise legally prohibited from receiving or
          using the Service or any Services under the laws of India.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">11.3&nbsp;</li>
        <li>
          You shall not host, display, upload, modify, publish, transmit, update
          or share any information, on the Portal or using the Services, which:
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">11.3.1&nbsp;</li>
            <li>
              Belongs to another person and to which you do not have any right
              to;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">11.3.2&nbsp;</li>
            <li>
              Is grossly harmful, harassing, blasphemous, defamatory, obscene,
              pornographic, paedophilic, libellous, invasive of another’s
              privacy, hateful, or racially, ethnically objectionable,
              disparaging, relating or encouraging money laundering or gambling
              or otherwise unlawful in any manner whatsoever; or unlawfully
              threatening or unlawfully harassing including but not limited to
              “indecent representation of women” within the meaning of the
              Indecent Representation of Women (Prohibition) Act 1986;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">11.3.3&nbsp;</li>
            <li>Is misleading in any way;</li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">11.3.4&nbsp;</li>
            <li>
              Is patently offensive to the online community, such as sexually
              explicit content, or content that promotes obscenity, paedophilia,
              racism, bigotry, hatred or physical harm of any kind against any
              group or individual;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">11.3.5&nbsp;</li>
            <li>Harassing or advocates harassment of another person;</li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">11.3.6&nbsp;</li>
            <li>
              Involves the transmission of “junk mail”, “chained letters”, or
              unsolicited mass mailing or “spamming”;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">11.3.7&nbsp;</li>
            <li>
              Promotes illegal activities or conduct that is abusive,
              threatening, obscene, defamatory or libellous;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">11.3.8&nbsp;</li>
            <li>
              Infringes upon or violates any third party’s rights (including,
              but not limited to, intellectual property rights, rights of
              privacy or rights of publicity);
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">11.3.9&nbsp;</li>
            <li>
              Promotes an illegal or unauthorized copy of another person’s
              copyrighted work;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">11.3.10&nbsp;</li>
            <li>
              Provides instructional information about illegal activities such
              as making and/ or buying illegal weapons, violating someone’s
              privacy, or providing or creating computer viruses;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">11.3.11&nbsp;</li>
            <li>
              Solicits gambling or engages in any gambling activity which we in
              our sole discretion believe is or could be construed to be as
              illegal;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">11.3.12&nbsp;</li>
            <li>Harms minors in any way;</li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">11.3.13&nbsp;</li>
            <li>Violates any law for the time being in force;</li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">11.3.14&nbsp;</li>
            <li>Impersonates another person;</li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">11.3.15&nbsp;</li>
            <li>
              Contains software viruses or any other computer code, files or
              programs designed to interupt, destroy or limit the functionality
              of any computer resource; or contains any trojan horses, worms,
              time bombs, cancelbots, easter eggs or other computer programming
              routines that may damage, detrimentally interfere with, diminish
              value of, surreptiously intercept or expropriate any system, data
              or personal information;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">11.3.16&nbsp;</li>
            <li>
              Threatens the unity, integrity, defence, security or sovereignty
              of India, friendly relations with foreign states, or public order
              or causes incitement to the commission of any cognizable offense
              or prevents investigation of any offense or is insulting any other
              nation.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">11.4&nbsp;</li>
        <li>
          Services may be made available for free of cost or for a specified
          cost as may be decided by the Company from time to time
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">11.5&nbsp;</li>
        <li>
          Pricing and availability of the Services are subject to change any
          time prior to the purchase.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">11.6&nbsp;</li>
        <li>
          Third-Party Fees: You may incur access or data fees from third parties
          (such as your internet provider or mobile carrier) in connection with
          your use of Services and of Portal. You are solely responsible for all
          such fees.{" "}
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">11.7&nbsp;</li>
        <li>
          Updates: You may need to install updates to the Portal or related
          software that we introduce from time to time to use of the Portal.
          Services originating from the Portal may communicate with the servers
          from time to time to check for available updates to the Services and
          to the functionality of the Portal, such as bug fixes, patches,
          enhanced functions, missing plug-ins and new versions (collectively,
          “Updates”). Your use of the Services you have installed requires that
          you have agreed to receive such automatically requested Updates.
          Further, You hereby agree that there maybe certain downtime of
          Services and the Portal on account of such Updates and modifications
          to the Portal.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">11.8&nbsp;</li>
        <li>
          Accuracy of Information: You agree that the information entered by you
          while profile creation/updating or using any of Services is true,
          current, complete and accurate in all respects. The Company is not
          responsible for any losses arising out of discrepancy in your data.
          You are solely responsible for maintaining confidentiality and
          security of your user account and for all activities that occur on or
          through your user account. The Company is not responsible for any
          losses arising out of the unauthorized use of your user account.{" "}
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">11.9&nbsp;</li>
        <li>
          When you use the Portal to avail the Services, you agree that you are
          involved in the transmission of personal information, including but
          not limited to your registration information and mobile number
          (collectively “PI”). You agree and consent to the Company collecting,
          using, storing and processing the above stated information, in
          accordance with the Privacy Policy.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>12. INDEMNITY AND LIMITATION OF LIABILITY: </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">12.1&nbsp;</li>
        <li>
          You hereby agree to indemnify, defend, and hold the Company, and its
          affiliates and the Company’s and Company’s affiliates’ agents,
          officers, personnel, directors, consultants, representatives,
          authorized users, employees, and assigns harmless from and against any
          and all losses, damages, liabilities and costs (including without
          limitation attorneys’ fees) arising from (i) your or your
          end-customer’s use or misuse of, or access to, the Portal or the
          Services; (ii) your or your end-customer’s violation of the Terms;
          (iii) infringement by you, or any third party (including your
          end-customer) using your account, of any intellectual property or
          other right of any person or entity, (iv) unauthorized use of the
          Services, or use of the Services in contravention of these Terms by
          you or your end-customer, and/or (v) any claims or disputes between
          you and any third party whose services or products you may have
          accessed through the Portal including for any claims relating to
          non-payment and/or misuse of such third party products and/or
          services. The Company reserves the right to assume the exclusive
          defence and control of any matter otherwise subject to indemnification
          by you, in which event you will assist and cooperate with the Company
          in asserting any available defence.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">&nbsp;12.2&nbsp;</li>
        <li>
          To the maximum extent permitted by applicable law, in no event shall
          the Company and/ or its affiliates be liable to you for any direct,
          special, incidental, indirect, punitive or consequential damages
          whatsoever (including, without limitation, damages for (a) loss of
          use, loss of business profits, business interruption, loss of
          information or data, or any other pecuniary loss; (b) any delay or
          inability to use the Portal or Services; (c) the provision of or
          failure to provide Services, or for any information or Services
          obtained through the Portal; or (d) otherwise arising out of the use
          of, or inability to use or access, the Portal or Services or for any
          security breach or any virus, bug, unauthorized intervention, defect,
          periodic maintenance or technical malfunctioning of the application,
          whether or not foreseeable or whether or not the Company has been
          advised of the possibility of such damages, or based on any theory of
          liability, including breach of contract or warranty, negligence or
          other tortious action, or any other claim arising out, of or in
          connection with, your use of, or access to, the Portal or the
          Services. Further, the Company shall not be liable to you for any
          temporary disablement, permanent discontinuance or modification of the
          Portal or the Services by the Company or for any consequences
          resulting from such actions. The Company shall be under no liability
          whatsoever in the event of non-availability of any portion of the
          Portal or subscribed Services on account of any virus, bug, periodic
          maintenance, upgradation, etc. of the Portal or the Services.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">&nbsp;12.3&nbsp;</li>
        <li>
          You shall be solely responsible for obtaining and maintaining any
          equipment and ancillary services (including the payment of any
          additional fees therefore) required to connect to, access or otherwise
          use the Services, including, without limitation, augmented reality,
          virtual reality and/ or mixed reality devices, mobile phones, video
          communication services, modems, hardware, servers, software, operating
          systems, networking, web servers, internet and telephone service
          (collectively, “equipment”). You will also be responsible for
          maintaining the security of the equipment and for all uses of the
          equipment with or without your knowledge or consent.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">&nbsp;12.4&nbsp;</li>
        <li>
          You are solely responsible for the Customer Content and other
          materials you transmit through the Service or share with other users
          or recipients. You will not transmit any Content that you did not
          create or that you do not own all right, title and interest in and to,
          including, without limitation, all copyright and rights of publicity
          contained therein. You represent and warrant that you own all your
          Customer Content or you have all rights that are necessary to grant us
          the license rights in your Customer Content under these Terms. You
          also represent and warrant that neither your Customer Content, nor
          your use and provision of your Customer Content to be made available
          through the Services, nor any use of your Customer Content by
          Tesseract on or through the Services will infringe, misappropriate or
          violate a third party’s intellectual property rights, or rights of
          publicity or privacy, or result in the violation of any applicable law
          or regulation. To the extent permitted by applicable law, you also
          agree that you will not exercise your moral rights (or equivalent
          rights under applicable laws), such as your right to be identified as
          the author of any of the Customer Contents, against Tesseract or any
          third party designated by Tesseract.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">&nbsp;12.5&nbsp;</li>
        <li>
          The Company and/or its respective affiliates makes no representations
          about the suitability, reliability, availability, timeliness and
          accuracy of the information, software and Services and related content
          including any content provided by third party service providers and
          licensors contained on the Portal for any purpose. All such
          information, software and services and related content are provided
          “as is” without warranty of any kind. The Company and/or its
          respective suppliers hereby disclaims all warranties and conditions
          with regard to this information, software, and Services and related
          content, including all implied warranties and conditions of
          merchantability, fitness for a particular purpose, title and
          non-infringement. The Company does not warrant that: (i) the Portal
          and Services will provide uninterrupted or error-free use and the
          Portal and Services will be uninterrupted or error-free; and (ii) the
          Portal and Services will operate free from loss, corruption, attack,
          viruses, interference, hacking, or other security intrusion.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">&nbsp;12.6&nbsp;</li>
        <li>
          You specifically agree that the Company shall not be responsible for
          unauthorised access to or alteration of your transmissions or data,
          any material or data sent or received or not sent or received, or any
          transactions entered into through the Portal. You specifically agree
          that the Company is not responsible or liable for any threatening,
          tory, obscene, offensive or illegal services or conduct of any other
          party or any infringement of another's rights, including intellectual
          property rights. You specifically agree that the Company is not
          responsible for any services sent using and/or included in the Portal
          by any third party. You are responsible for all activity that occurs
          in your account, regardless of whether undertaken by You, Your
          employees or a third party (including contractors, agents or your end
          customers), and the Company and its affiliates are not responsible for
          unauthorized access to Your account.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>
            13. TERMINATION (TEMPORARY AND PERMANENT DISABLEMENT):{" "}
          </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">&nbsp;13.1&nbsp;</li>
        <li>
          Unless otherwise provided in these Terms, the Services and access to
          the Portal offered to you may be terminated by the Company without
          assigning any reasons at any time at the sole discretion of the
          Company with or without notice to you and to exercise any other remedy
          available under law. Upon termination / suspension, you shall not have
          the right to use or access the Portal / Services.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">&nbsp;13.2&nbsp;</li>
        <li>
          The Company reserves the right to suspend and/ or terminate your
          access to the Services and Portal in case of any non-adherence to
          these Terms by you.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">&nbsp;13.3&nbsp;</li>
        <li>
          In the event any other user reports violation of any of their rights
          as a result of your or your end customer’s use of the Portal and/or
          the Services, the Company reserves the right to suspend or terminate
          your or your end customer’s access to the Portal and/or the Services.
          Any suspected illegal, fraudulent or abusive activity will be grounds
          for terminating access to the Portal and/or the Services. Upon
          suspension or termination, your right to avail the Services and access
          to the Portal will immediately cease and the Company reserves the
          right to remove or delete your information that is available,
          including but not limited to login and any other account information.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>14. GOVERNING LAW AND DISPUTE RESOLUTION: </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">&nbsp;14.1&nbsp;</li>
        <li>
          These terms of service are governed and construed in accordance with
          the laws of India without reference to any conflict of laws
          principles. You agree that subject to Clause 15 below, the courts in
          Mumbai, India shall have exclusive jurisdiction to hear disputes
          arising out of these Terms.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>15. DISPUTE RESOLUTION </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">&nbsp;15.1&nbsp;</li>
        <li>
          Any dispute, claim or controversy arising out of or relating to these
          Terms or the breach, termination, enforcement, interpretation or
          validity thereof, or your or your end customer’s use of the Portal or
          the Service or information to which it gives access, will be sought to
          be resolved by means of amicable discussions between the Company and
          you. However, if such amicable discussions do not result in resolution
          of a dispute, then such a dispute shall be determined by arbitration
          in India, before a sole arbitrator to be mutually appointed by the
          Company and you. Arbitration will be conducted in accordance with the
          Arbitration and Conciliation Act, 1996. The seat of such arbitration
          will be Mumbai, India. All proceedings of such arbitration, including,
          without limitation, any awards, will be in English language. The award
          will be final and binding on the parties.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>16. FORCE MAJEURE: </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">&nbsp;16.1&nbsp;</li>
        <li>
          The Company shall be under no liability whatsoever in the event of
          non-availability of any portion of the Portal or subscribed Services
          occasioned by act of God, war, disease, revolution, riot, civil
          commotion, strike, lockout, flood, fire, failure of any public
          utility, manmade disaster, infrastructure failure or any other cause
          whatsoever beyond the control of the Company.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>17. SEVERABILITY:</strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">&nbsp;17.1&nbsp;</li>
        <li>
          If any of the provisions of these Terms are deemed invalid, void, or
          for any reason unenforceable, that part of these Terms will be deemed
          severable and will not affect the validity and enforceability of any
          remaining provisions of these Terms.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>18. NOTICES AND CONTACT DETAILS:</strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">&nbsp;18.1&nbsp;</li>
        <li>
          All notices and other communications required or permitted under these
          Terms shall be in writing and in the English language. Such notices
          shall be sent to the email address used for communicating with you.
          The sending of a notice via the provided email address shall be
          considered a valid and effective means of delivering the
          communication.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>19. WAIVER:</strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">&nbsp;19.1&nbsp;</li>
        <li>
          No term of the Terms will be deemed waived, and no breach excused,
          unless such waiver or consent is in writing and signed by the Company.
          Any consent by the Company to, or waiver of a breach by you, whether
          expressed or implied, will not constitute consent to, waiver of, or
          excuse for any other different or subsequent breach.
        </li>
      </ul>
    </div>
  );
};

export default HorizonTNC;
